<div class="flex gap-1" [formGroup]="form">

    <p-select [options]="months" styleClass="w-24" formControlName="month" placeholder="Select Month" (onFocus)="controlFocused($event)" (onBlur)="controlTouched($event)">
    </p-select>
    <p-select [options]="days" styleClass="w-24" formControlName="day" placeholder="Select Day" (onFocus)="controlFocused($event)"  (onBlur)="controlTouched($event)"></p-select>
    
    <p-inputMask styleClass="w-12" formControlName="year" inputmode="numeric" mask="9999" placeholder="yyyy" (onFocus)="controlFocused($event)" (onBlur)="controlTouched($event)" ></p-inputMask>
</div>